// File: InsuranceAnalytics.js
import { Flex } from "antd";
import React from "react";

import TopTreatmentsApprovalVSPaymentComparison from "./TopTreatmentsApprovalVSPaymentComparison";
import InsuranceConversionRate from "./InsuranceConversionRate";
import MostClaimedTreatments from "./MostClaimedTreatments";
import InsuranceStatistics from "./InsuranceStatistics";
import InsuranceEngagement from "./InsuranceEngagement";

export default function InsuranceAnalytics() {
  return (
    <Flex vertical gap={30}>
      <Flex gap={30} justify="space-between">
        <MostClaimedTreatments />
        <InsuranceConversionRate />
        <InsuranceStatistics />
      </Flex>

      <Flex gap={30}>
        <TopTreatmentsApprovalVSPaymentComparison />
        <InsuranceEngagement />
      </Flex>
    </Flex>
  );
}
